import {AssignmentEntityModalForm} from './AssignmentEntityModalForm'

const AssignmentEntityModalFormWrapper = () => {
  return <AssignmentEntityModalForm />
}

export {AssignmentEntityModalFormWrapper}
